import api from './index';
let exports = {};

// 获取模板列表（条件：merchantId）
exports.getMerchantFreightTplList = function (params, callback) {// 获取运费模板分页列表
    api.post('/merchtLogis/merchant/freight/tpl/list/get')
    .data(params)
    .done(callback)
    .go();
};
// 更新模板
exports.saveMerchantFreightTpl = function (params, callback) {// 更新运费模板
    api.post('/merchtLogis/merchant/freight/tpl/save/do')
    .data(params)
    .done(callback)
    .go();
};
// 获取模板详细信息
exports.getMerchantFreightTplInfo = function (params, callback) {// 获取运费模板信息
    api.post('/merchtLogis/merchant/freight/tpl/info/get')
    .data(params)
    .done(callback)
    .go()
};
// 设为默认
exports.updateMerchantFreightTplDefaulted = function (params, callback) {// 设置为默认模板
    api.post('/merchtLogis/merchant/freight/tpl/defaulted/update/do')
    .data(params)
    .done(callback)
    .go()
};
// 删除
exports.deleteMerchantFreightTpl = function (params, callback) {// 删除模板
    api.post('/merchtLogis/merchant/freight/tpl/delete/do')
    .data(params)
    .done(callback)
    .go()
};
// 启 / 禁用
exports.updateMerchantFreightTplDisabed = function (params, callback) {// 启 / 禁用
    api.post('/merchtLogis/merchant/freight/tpl/disabled/update/do')
    .data(params)
    .done(callback)
    .go()
};

//------------------商户物流公司----------------------
//查询列表
exports.getMerchantLogisComList = function (data, callback) {// 根据上下文merchantId获取商户物流公司列表
    api.post('/merchtLogis/com/list/get')
    .data(data)
    .done(callback)
    .go();
};

//保存
exports.saveMerchantLogisCom = function (postData, callback) {// 保存商户物流公司
    api.post('/merchtLogis/com/save/do')
    .data(postData)
    .done(callback)
    .go();
};
//删除物流公司
exports.deleteMerchantLogisCom = function (data, callback) {// 刪除商户物流公司
    api.post('/merchtLogis/com/delete/do')
    .data(data)
    .done(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/merchtLogis.js
// module id = 147
// module chunks = 1